<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconShare_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M4 2a3 3 0 0 0-3 3v5a3 3 0 0 0 3 3h3.825V7.571L5.384 8.97c-.191.111-.426.044-.552-.157a.56.56 0 0 1 .047-.653l3.31-3.817a.41.41 0 0 1 .621 0l3.311 3.817a.56.56 0 0 1 .047.653c-.125.199-.358.268-.552.157l-2.44-1.398V13H13a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3z"
    />
</svg>
